/**
 * Register the MediaPipe Service Worker for caching the heavy model and WASM.
 * Resolves once the SW is active, or immediately if SW is unsupported.
 * Never rejects -- failures are swallowed so model loading can proceed via network.
 *
 * @returns {Promise<void>}
 */
export async function registerMediaPipeSw() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/mediapipe-sw.js');

    if (registration.active) {
      return;
    }

    const pending = registration.installing || registration.waiting;
    if (!pending) {
      return;
    }

    await new Promise(resolve => {
      pending.addEventListener('statechange', function handler() {
        if (pending.state === 'activated' || pending.state === 'redundant') {
          pending.removeEventListener('statechange', handler);
          resolve();
        }
      });
    });
  } catch (_err) {
    // SW registration failed -- fall back to normal network fetch
  }
}
